import React from 'react'
import styled from 'styled-components'
import Box from '@zuto/core/src/box'
import { textStyles } from '@zuto/theme/src/zuto/typography'
import { VehicleDetailsDataObject } from '../../../services/vehicle-service'
import { numberWithCommas } from '../../Questions/utils'

const FlexContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  text-align: start;
`

const PriceBox = styled(Box)`
  display: flex;
  align-items: baseline;
`

const MediaQueryBox = styled(Box)`
  ${textStyles.body.smallPrint.medium};
  
  @media (min-width: 435px) {
   ${textStyles.body.current.medium}
  }

  div { 
    overflow: hidden;
    text-overflow: ellipsis;
  }

`
interface VehicleInfoProps {
  vehicle: VehicleDetailsDataObject
  isClassifiedSource: boolean
}

const VehicleInfo = ({
  vehicle, isClassifiedSource
}: VehicleInfoProps) => (
  <>
    {isClassifiedSource && (
      <>
        <FlexContainer>
          <MediaQueryBox data-testid="vehicle-make-model">
            {vehicle.make}
            {' '}
            {vehicle.model}
          </MediaQueryBox>
          <MediaQueryBox data-testid="vehicle-price">
            £
            {vehicle.price ? numberWithCommas(vehicle.price) : 0}
          </MediaQueryBox>
          <MediaQueryBox data-testid="vehicle-details">
            {vehicle.registrationYear && `${vehicle.registrationYear} | `}
            {vehicle.transmission && ` ${vehicle.transmission} |`}
            {vehicle.fuelType && ` ${vehicle.fuelType}`}
          </MediaQueryBox>
        </FlexContainer>
      </>
    )}

    {!isClassifiedSource && (
      <>
        <FlexContainer>
          <Box textStyle="body.smallPrint.regular">
            Your vehicle price:
          </Box>
          <PriceBox data-testid="vehicle-price" textStyle="material.body.large.bold">
            {vehicle && vehicle.price && `£${numberWithCommas(vehicle.price)}`}
          </PriceBox>
        </FlexContainer>
      </>
    )}
  </>
)

export default VehicleInfo
